import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { AppShellV8 } from "../AppShellV8";

const REDIRECT_SECONDS = 3;

export function ClientPortal() {
  const navigate = useNavigate();
  const [secondsLeft, setSecondsLeft] = useState(REDIRECT_SECONDS);

  useEffect(() => {
    const redirect = setTimeout(() => {
      navigate("/agents/home");
    }, REDIRECT_SECONDS * 1000);

    const countdown = setInterval(() => {
      setSecondsLeft((s) => (s > 0 ? s - 1 : 0));
    }, 1000);

    return () => {
      clearTimeout(redirect);
      clearInterval(countdown);
    };
  }, [navigate]);

  return (
    <AppShellV8 activeApp="home" breadcrumb={["Client Portal"]} reviewCount={7}>
      <div className="flex h-full items-center justify-center">
        <div className="mx-auto max-w-md text-center">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-2xl bg-blue-50">
            <svg className="h-8 w-8 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 12l8.954-8.955a1.126 1.126 0 011.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" />
            </svg>
          </div>
          <h1 className="mb-2 text-lg font-semibold text-gray-900">Client Portal Merged into Home</h1>
          <p className="mb-1 text-[13px] text-gray-500">
            The Client Portal is now the client-role view of the Home screen.
          </p>
          <p className="mb-3 text-xs text-gray-400">
            When a client logs in, Home renders with their branding, showing pending approvals, recently completed items, and role-appropriate Quick Actions.
          </p>
          <p className="mb-6 rounded-lg border border-black/[0.06] bg-gray-50 px-3 py-2 text-xs text-gray-500">
            You&apos;re seeing this because you navigated to the old Client Portal route — it now lives inside Home.
          </p>
          <div className="flex flex-col items-center gap-2">
            <Link
              to="/agents/home"
              className="inline-flex items-center gap-2 rounded-lg bg-gray-900 px-4 py-2 text-[13px] font-medium text-white transition-all duration-150 hover:bg-gray-800 active:scale-[0.97]"
            >
              Go now
              <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
              </svg>
            </Link>
            <a
              href="#"
              title="The standalone Client Portal route was merged into Home so clients and operators share one screen that renders by role — fewer surfaces to maintain, one source of truth."
              className="text-xs text-gray-400 underline decoration-dotted underline-offset-2 transition-all duration-150 hover:text-gray-600"
            >
              Why did this change?
            </a>
          </div>
          <p className="mt-6 text-xs text-gray-400">
            Redirecting to Home in {secondsLeft} second{secondsLeft === 1 ? "" : "s"}…
          </p>
        </div>
      </div>
    </AppShellV8>
  );
}
